import type { BauvorhabenStatus } from '@/types';

/**
 * Geteilte deutsche Labels + Badge-Farben für den (abgeleiteten)
 * Bauvorhaben-Status — von der Listen-Spalte und der Leseansicht genutzt.
 * Farbsprache wie GewerkAccordion: geplant grau, aktiv amber,
 * abgeschlossen grün, abgebrochen rot.
 */
export const bauvorhabenStatusLabels: Record<BauvorhabenStatus, string> = {
  geplant: 'Nicht begonnen',
  aktiv: 'In Arbeit',
  abgeschlossen: 'Abgeschlossen',
  abgebrochen: 'Abgebrochen',
};

export const bauvorhabenStatusBadgeClasses: Record<BauvorhabenStatus, string> = {
  geplant: 'bg-gray-100 text-gray-800',
  aktiv: 'bg-amber-100 text-amber-800',
  abgeschlossen: 'bg-green-100 text-green-800',
  abgebrochen: 'bg-red-100 text-red-800',
};